import { useState, useCallback } from "react";

import ConfirmDialog from "components/_refactor/dialogs/confirm-dialog";

export default function useConfirmDialog() {
  const [dialogState, setDialogState] = useState(null);

  const confirm = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      setDialogState({
        message,
        title: options.title ?? "Confirmar",
        confirmLabel: options.confirmLabel ?? "Confirmar",
        cancelLabel: options.cancelLabel ?? "Cancelar",
        confirmColor: options.confirmColor ?? "primary",
        resolve,
      });
    });
  }, []);

  const closeDialog = useCallback((result) => {
    setDialogState((current) => {
      current?.resolve?.(result);
      return null;
    });
  }, []);

  function ConfirmDialogHost() {
    if (!dialogState) return null;

    return (
      <ConfirmDialog
        open
        title={dialogState.title}
        message={dialogState.message}
        confirmLabel={dialogState.confirmLabel}
        cancelLabel={dialogState.cancelLabel}
        confirmColor={dialogState.confirmColor}
        onCancel={() => closeDialog(false)}
        onConfirm={() => closeDialog(true)}
      />
    );
  }

  return { confirm, ConfirmDialog: ConfirmDialogHost };
}
